import { AVAILABLE_COUNTRIES, AVAILABLE_DIALING_CODES } from "@typings/globals";

const getDialingCode = (country: AVAILABLE_COUNTRIES): string => {
  switch (country) {
    case AVAILABLE_COUNTRIES.FR:
      return AVAILABLE_DIALING_CODES.FR;
    case AVAILABLE_COUNTRIES.CH:
      return AVAILABLE_DIALING_CODES.CH;
    case AVAILABLE_COUNTRIES.LU:
      return AVAILABLE_DIALING_CODES.LU;
    case AVAILABLE_COUNTRIES.PL:
      return AVAILABLE_DIALING_CODES.PL;
    case AVAILABLE_COUNTRIES.DE:
      return AVAILABLE_DIALING_CODES.DE;
    case AVAILABLE_COUNTRIES.IT:
      return AVAILABLE_DIALING_CODES.IT;
    case AVAILABLE_COUNTRIES.AT:
      return AVAILABLE_DIALING_CODES.AT;
    case AVAILABLE_COUNTRIES.BE:
      return AVAILABLE_DIALING_CODES.BE;
    case AVAILABLE_COUNTRIES.NL:
      return AVAILABLE_DIALING_CODES.NL;
    default:
      return AVAILABLE_DIALING_CODES.CH;
  }
};

export { getDialingCode };
